import PreviewHero from "./PreviewHero";
import PreviewBookingSection from "./PreviewBookingSection";
import PreviewFooter from "./PreviewFooter";

import PreviewAbout from "./PreviewAbout";
import PreviewHighlights from "./PreviewHighlights";
import PreviewMenu from "./PreviewMenu";
import PreviewGallery from "./PreviewGallery";
import PreviewPolicies from "./PreviewPolicies";
import PreviewContact from "./PreviewContact";

const FALLBACK_ORDER = ["about", "highlights", "menu", "gallery", "policies", "contact"];

export default function PreviewFrame({ config, device = "desktop" }) {
  const isMobile = device === "mobile";
  const theme = config?.theme || {};
  const primary = theme.primary || "#9df03d";

  const order =
    Array.isArray(config?.website?.sectionOrder) && config.website.sectionOrder.length
      ? config.website.sectionOrder
      : FALLBACK_ORDER;

  const sectionEnabled = (key) => {
    const node = config?.website?.[key];
    if (!node) return true;
    if (typeof node.enabled === "boolean") return node.enabled;
    return true;
  };

  const renderSection = (key) => {
    if (!sectionEnabled(key)) return null;

    switch (key) {
      case "about":
        return <PreviewAbout key="about" config={config} />;
      case "highlights":
        return <PreviewHighlights key="highlights" config={config} />;
      case "menu":
        return <PreviewMenu key="menu" config={config} />;
      case "gallery":
        return <PreviewGallery key="gallery" config={config} />;
      case "policies":
        return <PreviewPolicies key="policies" config={config} />;
      case "contact":
        return <PreviewContact key="contact" config={config} />;
      default:
        return null;
    }
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        // ✅ "front website" canvas
        background:
          `radial-gradient(900px 520px at 12% 0%, ${primary}14, transparent 55%),` +
          "radial-gradient(900px 520px at 90% 10%, rgba(99,102,241,0.10), transparent 52%)," +
          "linear-gradient(180deg, #f6f8fb 0%, #ffffff 55%, #ffffff 100%)",
        padding: 14,
        display: "flex",
        justifyContent: "center"
      }}
    >
      {/* ✅ Device shell (like browser) */}
      <div
        style={{
          width: isMobile ? 392 : "100%",
          maxWidth: isMobile ? 392 : 1240,
          borderRadius: 18,
          overflow: "hidden",
          background: "#ffffff",
          border: "1px solid rgba(15,23,42,0.10)",
          boxShadow: "0 18px 60px rgba(15,23,42,0.10)"
        }}
      >
        {/* HERO (dark/image as real website) */}
        <PreviewHero config={config} device={device} />

        {/* BODY (light) */}
        <div
          style={{
            background: "#ffffff",
            padding: isMobile ? "18px 14px" : "28px 28px"
          }}
        >
          {/* booking placeholder section */}
          <PreviewBookingSection config={config} />

          {/* micro-site sections */}
          {order.map(renderSection)}

          <PreviewFooter config={config} />
        </div>
      </div>
    </div>
  );
}
